import React from 'react';
import { Navigate } from 'react-router-dom';

function GuardedRoute({ element, isAuth }) {
  return isAuth === true ? element : <Navigate to='/login' replace />;
}

export default GuardedRoute;
